import React from "react";

const DetailsSection = () => {
  return (
    <div style={{ padding: "20px", backgroundColor: "#f4f4f4" }}>
      <h2>What We Offer</h2>
      <p>
        Whether you're looking for a one-off clean for specific areas or a
        full-home spring clean, we have the perfect service for you. Let us handle:
      </p>
      <ul>
        <li>Spring Cleaning</li>
        <li>Post-Renovation Cleaning</li>
        <li>Deep Cleaning</li>
        <li>End-of-Lease Cleaning</li>
      </ul>
    </div>
  );
};

export default DetailsSection;
